import { Alert, Link } from "@mui/material";
import * as React from "react";
import { P, H1, Content } from "../recurso_literario.js";
import { useContext } from "react"
import { DomainContext } from "../../Context/Context.js";

export const ComputoPanel = () => {
	const { cloudName } = useContext(DomainContext)

	return(
		<Content>
			<h2> Cómputo </h2>
			<P>
				{cloudName} te permite desplegar máquinas virtuales (VM en adelante).
				Las máquinas virtuales te permitirán tener un Windows o un Linux como si de un
				equipo físico se tratara. Pero con la ventaja de que no tenés que invertir
				en Hardware o preocuparte porque falle o quede obsoleto.

				Toda máquina virtual consta de un hardware virtual el cual determina la cantidad
				de memoria RAM y VCPU que tendrá la misma. Vas a poder cambiar el Hardware virtual
				de tu VM cuando lo desees.
			</P>

			<Alert severity="info">
				Tené en cuenta que algunos sistemas operativos como el
				Windows 2019 necesita de cierta cantidad de RAM y VCPU para funcionar. Tené en
				cuenta ésto al momento de modificar el Hardware virtual de tu VM
			</Alert>
			<br/>
			<P>
				En el Panel de Cómputo se crean y administran los servicios de Servidor Privado Virtual y Máquinas Virtuales.
			</P>
			<P>
				<img src="/img/TPanel.PNG" alt="Panel General" style={{marginLeft:"40px"}} />
			</P>
			<P>
				Si das click en el ícono de Cómputo, se te desplegarán las opciones de SVP y Máquina Virtual.
			</P>
				<br/><br/>
				<img src="/img/Computo/CButton.PNG" alt="Botón de Computo" style={{width:"30%", marginLeft:"40px"}} />
				<img src="/img/Computo/CPanel.PNG" alt="Panel de Computo" style={{width:"30%", marginLeft:"40px"}} />
				<br/><br/>
		</Content>
	)
}

export const ComputoSVP = () => {
	return(
		<Content>
			<h2> Servidor Privado Virtual </h2>
			<P>
				Dentro de Gestión encontraremos en Panel de Usuarios, que tiene la funcionalidad de crear
				y administrar los usuarios que gestionaran nuestros proyectos, a su vez también se pueden
				crear grupos de usuarios para una gestión más organizada de los mismos.
			</P>
			<P>
				<img src="/img/Computo/CSvp/CSvp_Button.png" alt="Botón de SVP" style={{width:"25%", marginLeft:"40px"}} />
			</P>
			<P>
				En esta sección se puede visualizar los Servidores Privados Virtuales que se han contratado.
			</P>
			<P>
				<img src="/img/Computo/CSvp/CSvp_View.png" alt="View de SVP" style={{width:"100%", marginLeft:"40px"}} />
			</P>
			<P>
				En la vista podemos encontrar la información de los datos de la SVP, señalados en la
				siguiente imagen en Azul, también tenemos la vista de filtros, representados por un botón
				de tres puntos, lo podemos ver en la señalación Roja y por último tenemos la paginación que
				podemos usar si tenemos muchos SVP contratados.
			</P>
			<P>
				<img src="/img/Computo/CSvp/CSvp_ViewDetail.png" alt="View de SVP" style={{width:"100%", marginLeft:"40px"}} />
			</P>
		</Content>
	)
}

export const ComputoMV = () => {
	const { domainName, cloudName } = useContext(DomainContext)

	return(
		<Content>
			<H1> Máquina Virtual </H1>
			<P>
				Una máquina virtual (VM en adelante) está definida principalmente por su
				hardware virtual y el S.O.  desplegado en ella. Toda máquina virtual dentro
				de {cloudName} está identificada por un UUID único. Recordá que todo
				elemento dentro de {cloudName} posee un UUID único.
			</P>

			<H1> Listar mis máquinas virtuales </H1>
			<P>
				Para listar las VM que tenés en el proyecto en el que te encontrás situado,
				debés dirigirte en el menú de la izquierda a Cómputo {">"} Máquina Virtual. Se te
				presentará el siguiente listado.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_View.png"
					 alt="Maquina Virtual Vista" style={{width:"100%", marginLeft:"40px"}} />
			</P>

			<P>
                Y posee los siguientes campos
            </P>

			<P>
				<b>NOMBRE</b> El nombre de la VM.<br/><br/>
				<b>ENCENDIDA</b> Determina si la VM se encuentra encendido o apagado. En la sección
				"Acciones" te explicamos cómo prenderla o apagarla.<br/><br/>
				<b>ESTADO</b> Determina el estado en el que se encuentra la VM. Generalmente lo
				verás en estado "Desplegado". Si se está realizando alguna acción sobre la VM
				verás el siguiente indicador: <img src="/img/Computo/VM/PP3.png" alt="indicador de accion en curso"/>.
				<br/><br/>
			</P>

			<P>
				Al hacer click sobre cualquiera de las filas del listado, estarás seleccionando la VM
				y pasarás a la pantalla con más información y la posibilidad de realizar ciertas
				acciones sobre ella.
			</P>

			{/************************************************************************************/}
			<h2> Visualizando información de la VM </h2>
			<P>
				En esta pantalla encontrarás toda la información necesaria de tu VM. En la parte
                superior tenés un menú para navegar.
			</P>

			<P>
				<img src="/img/Computo/VM/VM1.png" alt="Solapas VM" />
			</P>
			<P>
				El ícono <img src="/img/home.png" alt="indicador de accion en curso"/>
				te redirige a la pantalla principal donde se listan todas las VM.
            </P>

			<h3>Sección Detalles</h3>

			<P>
				Se muestran los detalles de la VM.
			</P>
            <P>
				<img src="/img/Computo/VM/VM2.png" alt="Solapas VM" />
            </P>
            <P>
                <b>NOMBRE:</b> El nombre de la VM. El lápiz a la derecha del nombre permite cambiar el mismo.<br/><br/>
                <b>UUID:</b> Es un identificador único. Si tenés algún problema podés contactar al soporte
                de {domainName} y utilizar este UUID o el NOMBRE para que nuestros técnicos
                identifiquen la VM.<br/><br/>
                <b>ENDENDIDA:</b> Indica si la VM se encuentra "encendida" o "apagada".<br/><br/>
                <b>ESTADO:</b> Indica si la VM se encuentra desplegada o realizando alguna tarea.<br/><br/>
            </P>

			<h3>Sección Hardware</h3>

			<P>
				Se muestran los detalles de hardware virtual de la VM.
			</P>
            <P>
				<img src="/img/Computo/VM/VM2H.png" alt="Solapas VM" />
            </P>
            <P>
                <b>Nombre:</b> Es el nombre que identifica el Hardware Virtual.<br/><br/>
                <b>VCPU:</b> La cantidad de virtual CPU asociada al hardware.<br/><br/>
                <b>RAM:</b> La cantidad de memoria RAM asociada al hardware.<br/>
            
			</P>
			
			<h3>Sección Consumos</h3>

			<P>
				Se muestra el precio por hora de la VM con la configuración indicada, el costo acumulado hasta el momento
				y la proyección a fin de mes del costo.
			</P>
            <P>
				<img src="/img/Computo/VM/VM2C.png" alt="Consumos" />
            </P>

            <h2>Sección Puertos de Red</h2>
            <P>
                Se muestran un listado de los puertos a los cuales está conectada la VM.
            </P>
            <P>
				<img src="/img/Computo/VM/VM3.png" alt="Solapas VM" />
            </P>

            <P>
				Las columnas del listado son las siguientes:<br/><br/>
                <b>RED</b> La red a la cual está conectado el puerto. No es un valor que puedas cambiar. <br/><br/>
                <b>DIRECCION MAC</b> La dirección MAC del puerto. No es un valor que puedas cambiar.<br/><br/>
                <b>IP</b> La IP privada del puerto según la red a donde lo has conectado.<br/><br/>
                <b>IP FLOTANTE</b> La IP Públicas en caso de que hayas adquirido una y quieras que es puerto la
				tenga asociada<br/>
                <b>ESTADO</b> El estado del puerto. Los estados posibles son Conectado | Desconectado<br/><br/>
            </P>

			Las siguientes son las tareas que podés realizar sobre un puerto seleccionado del listado


			<h2>Agregar una Máquina Virtual</h2>
			<P>
				Para agregar una nueva VM tenés que utilizar el botón Agregar de la parte superior
				izquierda de la pantalla desde donde podés visualizar las VM que tenés en tu proyecto. Tené
				en cuenta que la VM se desplegará en el proyecto en el que te encontrás actualmente.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_AddMachine.png"
					 alt="Agregar VM Botón"/>
			</P>
			<P>
				Esto te presentará el siguiente asistente para crear una nueva VM.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_AddView.png"
					 alt="Vista Agregar VM" style={{width:"100%"}} />
			</P>
			<P>
				En la parte izquierda encontrara el presupuesto que se irá modificando
				de acuerdo con la configuración que elijas en las distinas secciones del alta.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_Budget.png"
					 alt="Presupuesto VM"/>
			</P>
			<P>
				Como podés observar en la imagen, el precio de una VM queda determinada por el S.O.,
				el hardware virtual seleccionado (calidad) y la cantidad de espacio del disco. Además
				el asistente te mostrará el precio por hora de dicha configuración y el estimado a fin
				de mes si utilizás la VM sin apagarla (Una VM apagada no paga por el S.O. y el hardware
				virtual pero si por el espacio de disco).
			</P>

			<h3>Seleccionar el Sistema Operativo</h3>
			<P>
				<img src="/img/Computo/VM/altaVM_paso1.png" alt="alta VM paso 1"/>
			</P>
			
			<P>
				Como primer paso debés escoger la imagen del Sistema Operativo (S.O.) a utilizar.
				Podés elegir entre un gran abanico de opciones que mantendremos actualizadas.
			</P>
			<P>
				Podés refinar la búsqueda de las imágenes usando la lista Categoría que se
				encuentra en el centro a la derecha de la pantalla.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_Imagen3.png" alt="alta VM" />
			</P>
			<P>
				Una vez seleccionado el Sistema Operativo, podrás precionar el botón
				"Siguiente" en la esquina inferior derecha de la pantalla.
			</P>

			<h3>Nombre de la VM y hardware virtual</h3>
			<P>
				<img src="/img/Computo/VM/altaVM_paso2.png" alt="alta VM paso 2"/>
			</P>

			<P>
				Como segundo paso deberás darle un nombre a tu VM y elegir la cantidad de VCPU
				y RAM que utilizará tu VM.
				Posees una vasta cantidad de configuraciones para elegir la que mejor se aplique
				a tus necesidades. Cada calidad tiene asociado un precio por hora de utilización
				de la misma.
			</P>
			<P>
				Los nombres de las calidades de hardware virtual están nomenclados
				para que te sea fácil distinguirlos. La primer letra "V" se refiere a vcpu. El
				número que le sigue es la cantidad de vcpu. Le sigue la letra "M" haciendo
				referencia a la memoria y finalmente la cantidad de la misma. Así pues "V4.M16"
				hace referencia a una configuración de hardware con 4 Vcpu y 16 GB RAM.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_Hardware2.png"
					 alt="Información Hardware" style={{width:"50%", marginLeft:"40px"}} />
			</P>
			<P>
				Una vez asignado un nombre válido para tu VM y una calidad, podrás presionar el
				botón "Siguiente" de la esquina inferior derecha de la pantalla.
			</P>

			<h3>Tamaño del volumen principal</h3>
			<P>
				<img src="/img/Computo/VM/altaVM_paso3.png" alt="alta VM paso 3"/>
			</P>
			<P>
				Es momento de que indiques la cantidad de espacio en GB del volumen que deseas
				como almacenamiento. Ésto te proporcionará un primer volumen por bloques donde
				residirá tu filesystem. Más tarde, según tus necesidades, podrás ampliar este
				volumen o agregar volúmenes extras a tu VM.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_Storage1.png" alt="alta VM" />
			</P>
			<P>
				Recordá que el precio es por GB de almacenamiento por hora. Cada vez que modifiques
				el precio en este paso, se actualizará la información de la izquierda indicándote
				cuánto te saldrá el almacenamiento que deseas para tu VM.
			</P>

			<h3>Red</h3>
			<P>
				<img src="/img/Computo/VM/altaVM_paso4.png" alt="alta VM paso 4"/>
			</P>

			<P>
				Toda VM debe estar conectada a una red al momento de crearla. En este paso
				podrás indicar una o más de una red a la cual conectar tu VM. Una vez creada
				podrás agregar más puertos a otras redes o removerlos.
			</P>
			<P>
				Hacé click en el botón Agregar Red.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_Networkt2.png" alt="alta VM paso red" />
			</P>
			<P>
				Seleccioná la red de la lista desplegable. Acá verás todas las redes que existen
				en tu nube. Aún aquellas que no pertenecen al proyecto donde estás levantando la VM.
				Las redes son transversales a todos los proyectos.
			</P>
			<P>
				Podés optar por indicar la IP que deseas que tenga la VM en la red o que se asigne
				una por protocolo DHCP. Si especificás la IP, ésta debe ser válida para la red o
				de lo contrario obtendrás un error cuando se dispare el proceso que crea la VM
				resultando en la no creación de la misma.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_Networkt3.png" alt="alta VM paso red 2" />
			</P>
			<P>
				Una vez seleccionada al menos una red, se habilitará el botón "Siguiente" en
				la parte inferior derecha de la pantalla para que pases al siguiente paso.
			</P>

			<h3>Datos de Usuario</h3>
			<P>
				<img src="/img/Computo/VM/altaVM_paso5.png" alt="alta VM paso 5"/>
			</P>

			<P>
				Aquí podrás indicarle a la plataforma que cree un usuario con una contraseña
				una vez que se despliegue la VM. Ésto se logra gracias a una tecnología llamada
				CloudInit.
			</P>

			<P>
				<img src="/img/Computo/VM/altaVM_cloudInit.png" alt="alta VM cloudInit"/>
			</P>

			<P>
				CloudInit es el método de distribución múltiple estándar de la industria para la
				inicialización de instancias de nube multiplataforma. Es compatible con todos los
				principales proveedores de nube pública, sistemas de aprovisionamiento para
				infraestructura de nube privada e instalaciones básicas. Te dejamos el link para
				que accedas a su documentación:
			</P>
			<P>
				<Link href="https://cloudinit.readthedocs.io/en/latest">
				Cloud Init
				</Link>
			</P>

			<P>
				Si deseas que se ejecute tu propio template de CloudInit, puedes cambiar el switch
				que se muestra en pantalla de "Datos Básicos" a "Personalizado" y escribirlo.
			</P>

			<Alert>
				El poder utilizar o no el CloudInit, dependerá del S.O. que hayas seleccionado. Si
				el S.O. no lo soporta entonces no se te presentará esta sección.
			</Alert>

			<h3>Confirmar y crear</h3>
			<P>
				El último paso es visualizar la configuración que fuiste realizando y confirmarla
				para que se dispare la creación de la VM. Podrás volver sobre tus pasos con el botón
				"Anterior" en la esquina inferior izquierda para corregir cualquiera de las
				configuraciones.
			</P>
			<P>
				<img src="/img/Computo/VM/altaVM_paso6.png" alt="alta VM paso 6"/>
			</P>

			<P>
				<img src="/img/Computo/VM/CVMachine_Confirm1.png"
				alt="Información Confirmación" style={{width:"100%", marginLeft:"40px"}} />
			</P>

			<P>
				Una vez lanzada la creación de la VM, comenzará el proceso que podrás ver cuando
				finaliza en el desplegable de tareas.
			</P>
			<P>
				<img src="/img/Computo/VM/altaVM_tarea.png" alt="alta VM tarea"/>
			</P>
			<br/><br/>
			
		</Content>
	)
}
